let Cookies = require('js-cookie');

const COMPARED_BIKE_IDS = 'comparedBikeIds';

module.exports = {
    state: {
        comparedBikeIds: getComparedBikeIdsFromSession()
    },

    mutations: {
        addBikeId: function (state, id) {
            state.comparedBikeIds.push(id);
            saveComparedBikeIdsToSession(state.comparedBikeIds);
        },
        removeBikeId: function (state, id) {
            let index = state.comparedBikeIds.indexOf(id);

            if (index === -1) {
                console.warn('Trying to remove an element that does not exist in the array:', state.comparedBikeIds, id);
                return;
            }

            state.comparedBikeIds.splice(index, 1);

            saveComparedBikeIdsToSession(state.comparedBikeIds);
        }
    }
};

function getComparedBikeIdsFromSession() {
    return Cookies.getJSON(COMPARED_BIKE_IDS) || [];
}

function saveComparedBikeIdsToSession(bikeIds) {
    Cookies.set(COMPARED_BIKE_IDS, bikeIds, { expires: 365 });
}